
import { createContext } from "react";

type ISignalsContext = {
    parent: string;
    setParent: (name: string) => void;
    children: string;
    setChildren: (name: string) => void;
    callback: any;
    setCallback: (data: any) => void;
    
}

const SignalsContext = createContext<ISignalsContext>({
    setParent: () => {},
    parent: "",
    children: "",
    setChildren: () => {},
    callback: null,
    setCallback: (data: null) => {}
})


export default SignalsContext;